import { render } from "./Prefix.vue?vue&type=template&id=6822ca01&scoped=true"
import script from "./Prefix.vue?vue&type=script&lang=js"
export * from "./Prefix.vue?vue&type=script&lang=js"

import "./Prefix.vue?vue&type=style&index=0&id=6822ca01&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6822ca01"]])

export default __exports__